/**
 * @generated SignedSource<<909a4e2481544f05173dde0be37f6126>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingSource = "CUSTOMER" | "EVENT" | "GOLF_GENIUS" | "MEMBER" | "PACESETTER" | "STAFF" | "SUPREME" | "TOURNAMENT_MANAGEMENT";
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type OrderStatus = "CANCELED" | "DRAFT" | "EMPTY" | "FULLY_PAID" | "FULLY_REFUNDED" | "OPEN" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED";
export type PaymentSource = "CASH" | "NONCE" | "RAINCHECK" | "SQUARE_CARD_ON_FILE" | "SQUARE_GIFT_CARD" | "SQUARE_HOUSE_ACCOUNT";
export type PaymentStatus = "APPROVED" | "CANCELED" | "COMPLETED" | "FAILED" | "PENDING";
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
export type SquareGiftCardStatus = "ACTIVE" | "BLOCKED" | "DEACTIVATED" | "PENDING";
export type SquareLoyaltyRewardStatus = "DELETED" | "ISSUED" | "REDEEMED";
import { FragmentRefs } from "relay-runtime";
export type BookingCredits_booking$data = {
  readonly __typename: string;
  readonly appliedPromoCode: {
    readonly id: string;
  } | null | undefined;
  readonly id: string;
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly orderPayments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly amount: number;
              readonly paymentSource: PaymentSource | null | undefined;
              readonly refundedAmount: number;
              readonly squareGiftCard: {
                readonly ganLastFour: string | null | undefined;
                readonly id: string;
              } | null | undefined;
              readonly status: PaymentStatus | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: OrderStatus | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly ownerClient?: {
    readonly id?: string;
    readonly rainchecks?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly expirationDate: string | null | undefined;
          readonly facility: {
            readonly id: string;
            readonly raincheckConfiguration: {
              readonly limitRedemptionToFacility: boolean;
            };
          };
          readonly id: string;
          readonly squareGiftCard: {
            readonly balance: number;
            readonly status: SquareGiftCardStatus;
          };
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly squareGiftCards?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly balance: number;
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly patronOrders?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly squareLoyaltyRewards: ReadonlyArray<{
          readonly status: SquareLoyaltyRewardStatus;
        }>;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly paymentGiftCards?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly balance: number;
        readonly ganLastFour: string | null | undefined;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"BookingPaymentGiftCard_SquareGiftCard">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly paymentRainchecks?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"BookingPaymentRaincheck_Raincheck">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly paymentRequirements: {
    readonly prePaymentRequirement: PrePaymentRequirement;
  } | null | undefined;
  readonly projectedCreditApplications?: ReadonlyArray<{
    readonly amount: number;
    readonly paymentSource: PaymentSource;
    readonly raincheck: {
      readonly id: string;
    } | null | undefined;
    readonly squareGiftCard: {
      readonly ganLastFour: string | null | undefined;
      readonly id: string;
    };
  }>;
  readonly source: BookingSource | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly acceptsGiftCard: boolean;
        readonly acceptsRaincheck: boolean;
        readonly id: string;
      };
    };
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly totalDueAfterCredits?: number | null | undefined;
  readonly " $fragmentType": "BookingCredits_booking";
};
export type BookingCredits_booking$key = {
  readonly " $data"?: BookingCredits_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingCredits_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentSource",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ganLastFour",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareGiftCard",
  "kind": "LinkedField",
  "name": "squareGiftCard",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "kind": "Literal",
  "name": "hasNonZeroBalance",
  "value": true
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalDueAfterCredits",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "condition": "patronLoyalty",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectedCreditApplication",
        "kind": "LinkedField",
        "name": "projectedCreditApplications",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Raincheck",
            "kind": "LinkedField",
            "name": "raincheck",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "ownerClient",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "active",
                "value": true
              },
              (v7/*: any*/)
            ],
            "concreteType": "SquareGiftCardConnection",
            "kind": "LinkedField",
            "name": "squareGiftCards",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SquareGiftCardEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SquareGiftCard",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "squareGiftCards(active:true,hasNonZeroBalance:true)"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "expired",
                "value": false
              },
              (v7/*: any*/)
            ],
            "concreteType": "RaincheckConnection",
            "kind": "LinkedField",
            "name": "rainchecks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RaincheckEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Raincheck",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expirationDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SquareGiftCard",
                        "kind": "LinkedField",
                        "name": "squareGiftCard",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RaincheckConfiguration",
                            "kind": "LinkedField",
                            "name": "raincheckConfiguration",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "limitRedemptionToFacility",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "rainchecks(expired:false,hasNonZeroBalance:true)"
          }
        ],
        "type": "Customer",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "SquareGiftCardConnection",
    "kind": "LinkedField",
    "name": "paymentGiftCards",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SquareGiftCardEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SquareGiftCard",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BookingPaymentGiftCard_SquareGiftCard"
              },
              (v0/*: any*/),
              (v8/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RaincheckConnection",
    "kind": "LinkedField",
    "name": "paymentRainchecks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RaincheckEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Raincheck",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BookingPaymentRaincheck_Raincheck"
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingCredits_booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BookingPaymentRequirements",
      "kind": "LinkedField",
      "name": "paymentRequirements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prePaymentRequirement",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PromoCode",
      "kind": "LinkedField",
      "name": "appliedPromoCode",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrderPaymentConnection",
                  "kind": "LinkedField",
                  "name": "orderPayments",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderPaymentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "OrderPayment",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "refundedAmount",
                              "storageKey": null
                            },
                            (v2/*: any*/),
                            (v4/*: any*/),
                            (v6/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "patronLoyalty",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "patronOrders",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            }
          ],
          "concreteType": "OrderConnection",
          "kind": "LinkedField",
          "name": "orders",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Order",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SquareLoyaltyReward",
                      "kind": "LinkedField",
                      "name": "squareLoyaltyRewards",
                      "plural": true,
                      "selections": [
                        (v2/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "orders(first:1)"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "acceptsGiftCard",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "acceptsRaincheck",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "f5af766bcb815bc4ba6d6feaef553046";

export default node;
